import { useEffect, useState, type ReactNode } from 'react';
import { checarSessao } from './api';
import LoginScreen from './LoginScreen';

type Estado = 'checando' | 'fora' | 'dentro';

/**
 * Porta de entrada. Não renderiza o app (router) enquanto não houver sessão.
 * Qualquer 401 nas chamadas de API dispara o evento `auth:expirou` (ver
 * features/pedidos/api.ts) e devolve o usuário para a tela de senha.
 */
export default function AuthGate({ children }: { children: ReactNode }) {
  const [estado, setEstado] = useState<Estado>('checando');

  useEffect(() => {
    let vivo = true;
    checarSessao().then((ok) => {
      if (vivo) setEstado(ok ? 'dentro' : 'fora');
    });
    const onExpirou = () => setEstado('fora');
    window.addEventListener('auth:expirou', onExpirou);
    return () => {
      vivo = false;
      window.removeEventListener('auth:expirou', onExpirou);
    };
  }, []);

  if (estado === 'checando') {
    return (
      <div className="app-shell min-h-screen w-full flex items-center justify-center">
        <span className="font-display italic text-[18px] text-fg-3 animate-fadeIn">
          Abrindo o jardim…
        </span>
      </div>
    );
  }

  if (estado === 'fora') {
    return <LoginScreen onEntrou={() => setEstado('dentro')} />;
  }

  return <>{children}</>;
}
